import { Link, useLocation } from "react-router-dom";

const LINKS = [
  { to: "/strategic-assets", label: "Overview" },
  { to: "/strategic-assets/intelligence", label: "Intelligence" },
  { to: "/strategic-assets/tax-optimization", label: "Tax Optimization" },
  { to: "/strategic-assets/recovery", label: "Recovery" },
  { to: "/strategic-assets/acquisitions", label: "Acquisitions" },
  { to: "/strategic-assets/real-estate", label: "Real Estate" },
];

// Local subsection nav for Strategic Assets. Page-level brand identification is
// intentionally omitted — the persistent global JMH header sits above this.
export const StrategicAssetsNav = () => {
  const { pathname } = useLocation();
  return (
    <div className="pt-20 md:pt-24 px-6" data-testid="sa-local-nav">
      <div className="max-w-5xl mx-auto border-b border-[rgba(180,139,63,0.16)] pb-4">
        <nav className="flex items-center gap-x-6 gap-y-2 flex-wrap" aria-label="Strategic Assets sections">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`sa-nav-${l.label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/^-|-$/g, "")}`}
              className={`font-display uppercase tracking-wide2 text-[10px] link-underline transition-colors ${pathname === l.to ? "text-[var(--gold-lite)]" : "text-[var(--bone)]/80 hover:text-[var(--gold-lite)]"}`}
            >
              {l.label}
            </Link>
          ))}
        </nav>
      </div>
    </div>
  );
};
